import React, { useEffect, useState } from 'react'
import className from 'classnames'
import useAlert from '../../../hooks/useAlert'
import * as style from './alert.module.scss'
import { ALERT_TYPE_LINK_COPY } from '../../../types/types'

const AlertNotification = () => {
  const [fade, setFade] = useState(false)

  const { error, removeError } = useAlert()

  useEffect(() => {
    setFade(!!error)

    setTimeout(() => {
      setFade(false)
    }, 3800)

    setTimeout(() => {
      removeError()
    }, 4000)
  }, [error])

  return (
    <>
      {!!error && (
        <div className={className(style.body, fade && style.fade)}>
          {error && error.message && (
            <p
              className={className(
                style.text,
                error.type === ALERT_TYPE_LINK_COPY && style.linkCopy
              )}
            >
              {error.message}
            </p>
          )}
        </div>
      )}
    </>
  )
}

export default AlertNotification
